/**
 * Le panel a quatre espaces :
 * - supervision : dashboard, staff, modération... (le panel actuel)
 * - configuration : édition in-game (packs Minecraft : blocks, items, entities, crafts)
 * - deploiement : reprise du produit CI/CD (déploiements, containers, environnements)
 * - statistiques : analyse des données du serveur et des joueurs
 *
 * L'espace est ENTIÈREMENT DÉRIVÉ de la route (source de vérité unique = l'URL).
 * Il n'y a volontairement PAS de store : Header et Sidebar calculent l'espace au rendu
 * via {@link spaceFromPath}(useLocation().pathname). Cela garantit qu'onglet + sidebar
 * sont toujours cohérents avec l'URL dès le premier paint (aucun flash au chargement,
 * au login SPA, ni au Back/Forward inter-espaces).
 */
export type PanelSpace = 'supervision' | 'configuration' | 'deploiement' | 'statistiques' | 'parametres';

/** Déduit l'espace courant à partir du chemin d'URL. */
export function spaceFromPath(pathname: string): PanelSpace {
  if (pathname.startsWith('/config')) return 'configuration';
  if (pathname.startsWith('/deploiement')) return 'deploiement';
  // '/stats' et '/stats/players'. Pas de collision avec '/staff', qui ne commence pas par '/stats'.
  if (pathname.startsWith('/stats')) return 'statistiques';
  // Paramètres généraux (écrou du header) : pas d'onglet dans le bandeau, mais une barre latérale
  // propre (réglages du panel pour les admins, Pack / Fichiers / Containers selon les droits).
  if (pathname.startsWith('/parametres')) return 'parametres';
  return 'supervision';
}
